<template>
  <div class="page-wrapper">
    <div class="page-header">
      <div class="page-header-left">
        <h3>Plan and Billing</h3>
        <p class="subtitle" v-if="!showFeatures">Manage subscription and payment</p>
        <p class="subtitle" v-if="showFeatures">Active Features</p>
      </div>
      <div class="plan-actions">
        <DropdownButton class="green" :content="planActions" @onSubmit="handlePlanAction">
          <span class="dropdown-icon">Actions</span>
        </DropdownButton>
      </div>
    </div>

    <div class="page-body">
      <div v-if="!showFeatures" class="page-body-header">
        <h2>Current Plan</h2>
        <widget-button class="btn-secondary" @click="managePlan">
          Change Plan
        </widget-button>
      </div>

      <div v-if="!showFeatures" class="page-body-content">
        <div class="subscription-card" @click="showFeatures = true">
          <div class="card-header">
            <div class="plan-info">
              <div class="plan-info-header">
                <span class="plan-type">Weekly</span>
                <div class="plan-name-status">
                  <span class="plan-name">Standard Plan</span>
                  <span class="status-badge active">• Active</span>
                </div>
              </div>
              <div class="plan-details">
                <div class="plan-price">20 USD / Week</div>
                <div class="renewal-date">Renewal at: 21/2/2024</div>
              </div>
            </div>

          </div>
          <div class="card-actions">
            <div class="action-buttons">

              <widget-button class="btn-primary" @click="managePayments">
                Manage Payments
              </widget-button>
              <widget-button class="btn-secondary outline" @click="cancelPlan">
                Cancel Plan
              </widget-button>
            </div>
          </div>
        </div>
      </div>

      <Features v-if="showFeatures" />

    </div>

  </div>
</template>

<script>
import { eventBus } from "@/main";
import DropdownButton from "@/components/DropdownButton.vue";
import widgetButton from "@/components/widget/widgetButton.vue";
import Features from "./Features.vue";

export default {
  components: {
    DropdownButton,
    widgetButton,
    Features
  },
  data: () => ({
    planActions: [
      { name: "Manage", value: "manage" },
      { name: "Suspend/Pause", value: "suspend" },
      { name: "Cancel", value: "cancel" }
    ],
    subscriptionData: {
      planType: "Weekly",
      planName: "Standard Plan",
      status: "Active",
      price: "20 USD / Week",
      renewalDate: "21/2/2024"
    },
    showFeatures: false
  }),
  mounted() {
    let vm = this;
    // Get subscription data
    vm.loadSubscriptionData();
  },
  methods: {
    loadSubscriptionData() {
      // Load subscription data from API
      console.log("Loading subscription data...");
    },
    handlePlanAction(action) {
      console.log("Plan action:", action);
      switch (action) {
        case "manage":
          this.managePlan();
          break;
        case "suspend":
          this.suspendPlan();
          break;
        case "cancel":
          this.cancelPlan();
          break;
      }
    },
    managePlan() {
      console.log("Managing plan...");
      // Navigate to plan management
    },
    managePayments() {
      console.log("Managing payments...");
      // Navigate to payment management
    },
    suspendPlan() {
      console.log("Suspending plan...");
      // Handle plan suspension
    },
    cancelPlan() {
      console.log("Cancelling plan...");
      // Handle plan cancellation
    }
  },
  watch: {

  },
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f6f6f6;

  .page-header {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    padding: 10px;
    border-radius: 10px;

    .page-header-left {
      h3 {
        margin: 0;
        font-size: 24px;
        font-weight: 600;
        color: #333;
      }

      .subtitle {
        margin: 5px 0 0 0;
        color: #666;
        font-size: 14px;
      }
    }

    .plan-actions {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 10px;
    }
  }

  .page-body {
    display: flex;
    flex-direction: column;
    gap: 20px;
    background-color: #fff;
    border-radius: 10px;
    height: calc(100% - 100px);
    overflow-y: auto;

    .page-body-header {
      display: flex;
      align-items: center;
      padding: 10px;
      border-radius: 10px;

      h2 {
        margin-right: 20px;
      }
    }

    .page-body-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 20px;
      padding: 10px;

      .subscription-card {
        background: white;
        width: 40%;
        cursor: pointer;


        .card-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 25px;
          border: 1px solid #f0f0f0;
          padding: 25px;
          border-radius: 10px;

          .plan-info {
            flex: 1;

            .plan-info-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 10px;

              .plan-type {
                font-size: 14px;
                color: #666;
                margin-bottom: 5px;
                display: block;
              }

              .plan-name-status {
                display: flex;
                align-items: center;
                gap: 15px;
                margin-bottom: 10px;

                .plan-name {
                  font-size: 16px;
                  font-weight: 500;
                  color: #333;
                }

                .status-badge {
                  font-size: 14px;
                  color: #1ba5a4;
                  font-weight: 500;

                  &.active {
                    color: #1ba5a4;
                  }
                }
              }

            }

            .plan-details {


              .plan-price {
                font-size: 28px;
                font-weight: 600;
                color: #333;
                margin-bottom: 8px;
              }

              .renewal-date {
                font-size: 14px;
                color: #666;
              }
            }
          }

          .plan-actions {
            position: relative;
          }
        }

        .card-actions {
          .action-buttons {
            display: flex;
            gap: 15px;
            flex-wrap: wrap;

            .widget_button {
              height: 40px;
              padding: 0 20px;
              font-size: 14px;
              font-weight: 500;
              border-radius: 8px;

              &.btn-primary {
                background: #1ba5a4;
                color: white;
              }

              &.btn-secondary.outline {
                background: transparent;
                color: #dc3545;
                border: 1px solid #dc3545;

                &:hover {
                  background: #dc3545;
                  color: white;
                }
              }
            }
          }
        }
      }
    }


  }
}

// Responsive design
@media (max-width: 768px) {
  .page-wrapper {
    padding: 15px;

    .subscription-card {
      padding: 20px;

      .card-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
      }

      .card-actions {
        .action-buttons {
          flex-direction: column;

          .widget_button {
            width: 100%;
          }
        }
      }
    }


  }
}
</style>
